export default "__VITE_ASSET__aE5UsPYy__"